import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { PageTransition } from '@/components/shared/PageTransition';
import { OfflineBanner } from '@/components/shared/OfflineBanner';
import { InstallPrompt } from '@/components/shared/InstallPrompt';

/**
 * Root application chrome: responsive header (desktop) + bottom tab bar
 * (mobile), with the active route rendered inside a page transition.
 */
export function AppShell() {
  const location = useLocation();

  return (
    <div className="min-h-svh bg-bg pt-safe">
      <Header />
      <OfflineBanner />
      <main className="mx-auto max-w-5xl px-4 pb-nav-safe pt-4 sm:px-6 sm:pb-12">
        <AnimatePresence mode="wait" initial={false}>
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </AnimatePresence>
      </main>
      <BottomNav />
      <InstallPrompt />
    </div>
  );
}
